/**
 * V17: 章一教学包装升级 — 战斗教学状态传递
 *
 * 用途：将 hintDensity / unlockedApis 从 screen-2（编辑器/加载教学数据）
 *       传递到 screen-4（战斗 CONSOLE + tips）和 screen-5（结果页庆祝）
 *
 * 方式：sessionStorage 临时中转，不建新状态机
 */
const SESSION_KEY = "battlecode-teaching-state";

export interface BattleTeachingState {
  hintDensity: number;       // 0=静默 1=关键 3=适中 5=完整
  unlockedApis: string[];     // 本关首次出现的新 API
  levelId: string;            // 关卡 ID（用于 first-clear 检测）
}

/** 存储教学状态（screen-2 调用） */
export function storeBattleTeachingState(state: BattleTeachingState): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
}

/** 读取教学状态（screen-4 / screen-5 调用） */
export function getBattleTeachingState(): BattleTeachingState | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as BattleTeachingState;
  } catch {
    return null;
  }
}

/** 清除教学状态（战斗结束后清理） */
export function clearBattleTeachingState(): void {
  sessionStorage.removeItem(SESSION_KEY);
}
